<template>
  <div id="app">
    <div>
      <div class="aip-title">
        <div class="aip-title-left">
          <span>FAQ</span>
        </div>
        <div class="aip-title-right">
          <img class="app-img" :src="logo" alt="" />
        </div>
      </div>

      <div class="faq" v-if="list.length != 0">
        <div v-for="item in list" :key="item.id">
          <div class="faq-h48" @click="clickIcon(item.iconStr, item.id)">
            <span class="contentTitle">{{ item.title }}</span>
            <i
              class="el-icon-arrow-right"
              v-if="item.iconStr === 1"
              style="float: right; padding-top: 14px"
            ></i>
            <i
              class="el-icon-arrow-down"
              v-else
              style="float: right; padding-top: 14px"
            ></i>
          </div>
          <ul v-if="item.iconStr === 2">
            <li
              class="contentItem"
              v-for="item1 in item.children"
              :key="item1.id"
              @click="clickCollapseItem(item1)"
            >
              {{ item1.title }}
            </li>
          </ul>
        </div>
      </div>
      <div class="faq-empty" v-else>
        None 
      </div> 
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "FAQ",
  props: {
    msg: String,
  },
  data() {
    return {
      queryParams: "",
      id: "",
      env: process.env.VUE_APP_BASE_API,
      logo: require("@/assets/logo.png"),
      iconStr: 1,
      list: [],
    };
  },
  async mounted() {
    this.queryParams = await this.getQueryParams();
    const url = `${this.env}/v2/open/faq/detail/classify?page=1&limit=1000&lang=${this.queryParams?.lang || "en"}`;
    let headers = {
      "Content-Type": "application/json",
      "x-api-version": this.queryParams["version"] ?? 0,
      "x-current-platform": this.queryParams["platform"] ?? "android",
      "x-app-channel": this.queryParams["channel"] ?? "googleplay",
      "x-current-package": this.queryParams["package"] ?? "",
    };
    axios
      .get(url, { headers: headers })
      .then((res) => {
        if (res.data.data.items && res.data.data.items.length !== 0) {
          this.list = res.data.data.items || [];
          this.list.forEach((item) => {
            item.iconStr = 1;
            const url = `${this.env}/v2/open/faq/classify/detail/${item.id}?page=1&limit=999&lang=${this.queryParams?.lang || "en"}`;
            axios
              .get(url, { headers: headers })
              .then((child) => {
                item.children = child.data.data.items || [];
              })
              .catch((error) => {
                console.error(error);
              });
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    getQueryParams() {
      const params = {};
      const queryString = window.location.search.substring(1);
      const pairs = queryString.split("&");
      for (let pair of pairs) {
        const [key, value] = pair.split("=");
        params[decodeURIComponent(key)] = decodeURIComponent(value);
      }
      return params;
    },
    openApp() {
      // window.flutter_inappwebview?.callHandler("sendMessage", {
      //   message: "JumpIntelligentGuidance",
      // });
      if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
        window.flutter_inappwebview.callHandler('sendMessage', {
          message: "JumpIntelligentGuidance"
        })
      } else if (window.sendMessage !== undefined) {
        window.sendMessage.postMessage('JumpIntelligentGuidance');
      }
    },
    goBack() {
      // window.flutter_inappwebview?.callHandler("sendMessage", {
      //   message: "JumpHome",
      // });
      if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
        window.flutter_inappwebview.callHandler('sendMessage', {
          message: "JumpHome"
        })
      } else if (window.sendMessage !== undefined) {
        window.sendMessage.postMessage('JumpHome');
      }
    },
    clickCollapseItem(val) {
      this.$router.push({
        path: "/FAQContent",
        query: {
          id: val.id,
        },
      });
      this.id = val.id;
    },
    clickIcon(val, id) {
      this.list.forEach((item) => {
        if (item.id === id) {
          item.iconStr = val === 1 ? 2 : 1;
          this.$forceUpdate();
        }
      });
    },
  },
};
</script>

<style scoped>
#app {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.app-title {
  margin: -35px auto 24px auto;
  text-align: center;
  z-index: 999;
}

.header {
  font-family: PingFang SC, serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0em;
  color: #0e273b;
  z-index: 1;
}

.headerContent {
  font-family: PingFang SC, serif;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0em;
  color: #3d3d3d;
  padding-left: 16px;
  height: 48px;
  line-height: 48px;
}

.headerContent2 {
  font-family: PingFang SC, serif;
  font-size: 21px;
  font-weight: 500;
  letter-spacing: 0em;
  color: #3d3d3d;
  padding-left: 0px;
  height: 48px;
  line-height: 48px;
}

.headerContent3 {
  font-family: PingFang SC, serif;
  font-size: 21px;
  font-weight: 500;
  color: #3d3d3d;
  padding-left: 0px;
  height: 48px;
  text-align: left;
  padding-top: 12px;
}

.app-subtitle {
  font-family: PingFang SC, serif;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0em;
  color: #3d3d3d;
  display: flex;
  text-align: left;
  height: 48px;
  line-height: 48px;
  margin-bottom: 16px;
}

.app-subtitle2 {
  font-family: PingFang SC, serif;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0em;
  color: #3d3d3d;
  display: flex;
  text-align: left;
  height: 48px;
  margin-bottom: 16px;
}

.app-img {
  width: 100px;
  height: 100px;
}

.collapseItem {
  text-align: left;
  font-family: PingFang SC, serif;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #f65e3d;
  padding: 24px 0px 0px 20px;
}

.item2 {
  font-family: PingFang SC, serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  color: #f65e3d;
  text-align: left;
  margin-bottom: 4px;
}

.item3 {
  font-family: PingFang SC, serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0em;
  color: #767676;
  text-align: left;
}

::v-deep .el-collapse-item__header,
::v-deep .el-collapse-item__wrap {
  border-radius: 10px;
  padding-left: 16px;
  font-family: PingFang SC, serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  color: #0e273b;
}

ul li {
  list-style: none;
}

.contentTitle {
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #0E273B;
  z-index: 1;
}

.contentItem {
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  padding: 14px 4px 10px 4px;
  font-feature-settings: "kern" on;
  color: #F65E3D;
}

.intelligent {
  flex: 1;
  padding: 16px 0px 16px 24px;
}

.intelligent-header {
  display: flex;
  height: 76px;
  border-radius: 24px;
  margin-bottom: 16px;
  background: #fff;
}

.intelligent-title {
  padding: 16px 0px 16px 50px;
}

.intelligent-img {
  width: 44px;
  height: 44px;
}

.intelligent-img-title {
  padding: 16px;
}

.faq {
  border-radius: 24px;
  border-radius: 24px;
  background: #ffffff;
  text-align: left;
  padding: 16px;
  margin: 0 auto;
}

.faq-h48 {
  height: 48px;
  line-height: 48px;
}
.aip-title {
  display: flex;
  justify-content: space-between;
}
.aip-title-left {
  font-family: Source Han Sans;
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: normal;
  color: #3d3d3d;
  padding-top: 27px;
}
.aip-title-right {
  margin-right: -16px;
}
.faq-empty {
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
